module.exports = __webpack_public_path__ + "img/logo.bb56660b.png";